export class FeaturesPresenter{
    getLineOptions() {
        return [
          { value: "main-line", displayText: "Main Line" },
          { value: "crv-line", displayText: "Crv Line" },
        ];
      }
}